import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {
    TokenAuthServiceProxy,
    AuthenticateModel,
    AuthenticateResultModel,
   
    TenantListDto,
} from "@shared/service-proxies/service-proxies";

import { UrlHelper } from "@shared/helpers/UrlHelper";
import { AppConsts } from "@shared/AppConsts";
 
import { TokenService } from "@abp/auth/token.service";
import { UtilsService } from "@abp/utils/utils.service";

import * as _ from "lodash";
 

 
@Injectable()
export class QrMenaAuthService {
    static readonly twoFactorRememberClientTokenName =
        "TwoFactorRememberClientToken";

    authenticateModel: AuthenticateModel;
    authenticateResult: AuthenticateResultModel;


    rememberMe: boolean;

    constructor(
        private _tokenAuthService: TokenAuthServiceProxy,
     
        private _utilsService: UtilsService,
 
        private _tokenService: TokenService,
       
    ) {
         this.authenticateModel=new AuthenticateModel()
    }

   

    authenticateUsingPincode(finallyCallback?: () => void): void {
        finallyCallback = finallyCallback || (() => {});

        // We may switch to localStorage instead of cookies
        this.authenticateModel.twoFactorRememberClientToken =
            this._utilsService.getCookieValue(
                QrMenaAuthService.twoFactorRememberClientTokenName
            );
        this.authenticateModel.singleSignIn = UrlHelper.getSingleSignIn();
        this.authenticateModel.returnUrl = UrlHelper.getReturnUrl();

        this._tokenAuthService
            .authenticateByPinCode(this.authenticateModel)
            .finally(finallyCallback)
            .subscribe((result: AuthenticateResultModel) => {
                 this.login(
                result.accessToken,
                result.encryptedAccessToken,
                result.expireInSeconds,
                false,
                result.twoFactorRememberClientToken,
                null,
                result.tenantData,
                result.userId.toString()
            );
            console.log(result)
            });
    }

    
    init(): void {
       
    }

    private login(
        accessToken: string,
        encryptedAccessToken: string,
        expireInSeconds: number,
        rememberMe?: boolean,
        twoFactorRememberClientToken?: string,
        redirectUrl?: string,
        tenant?: TenantListDto,
        userId?:string
    ): void {
        let tokenExpireDate = rememberMe
            ? new Date(new Date().getTime() + 1000 * expireInSeconds)
            : undefined;

        this._tokenService.setToken(accessToken, tokenExpireDate);

        this._utilsService.setCookieValue(
            AppConsts.authorization.encrptedAuthTokenName,
            encryptedAccessToken,
            tokenExpireDate,
            abp.appPath
        );
        // set
     //  sessionStorage.setItem(AppConsts.appSessionItems.tenantInfo,JSON.stringify(tenant));
        // save tenant information in cookies
        this._utilsService.setCookieValue(
            AppConsts.appSessionItems.tenantInfo,
            JSON.stringify(tenant),
            new Date(new Date().getTime() + 365 * 86400000), // 1 year
            abp.appPath
        );
        // is parent tenant to false
        abp.utils.setCookieValue(
            AppConsts.appSessionItems.isParentTenantManage,
            "0",
            new Date(new Date().getTime() + 365 * 86400000), // 1 year
            abp.appPath
        );
     
        abp.utils.setCookieValue(
            AppConsts.appSessionItems.userId,
           userId,
            new Date(new Date().getTime() + 365 * 86400000), // 1 year
            abp.appPath
        );
       
    }

     

}



// WEBPACK FOOTER //
// ./src/QrMena/services/qrmena-auth.service.ts